<script>
export default {
  inject: {
    client: { from: 'clientStore' },
    accounts: { from: 'accountsStore' }
  },

  computed: {
    // Logged in account
    account () {
      return this.accounts.account
    },

    // Administrators get the administration of accounts on top of their own account
    isAdministrator () {
      return Boolean(this.account?.isAdministrator)
    },

    // Menu item corresponding to the current route. Driving the tabs explicitly from the route,
    // rather than relying on route matching inside the tabs, keeps the right tab selected
    // after a page reload and also while editing an account, which is a nested view of the list
    activeTab () {
      const { name } = this.$route
      return name === 'account-editor' ? 'accounts-list' : name
    },

    // Menu items, each leading to a nested view with its own URL
    menu () {
      const { isAdministrator } = this
      return isAdministrator
        ? [
          { name: 'accounts-summary', icon: 'home', label: 'Welcome' },
          { name: 'my-account', icon: 'person', label: 'My Account' },
          { name: 'accounts-list', icon: 'group', label: 'All Accounts' }
        ]
        : [
          { name: 'accounts-home', icon: 'home', label: 'Welcome' },
          { name: 'my-account', icon: 'person', label: 'My Account' }
        ]
    }
  }
}

</script>

<template>
  <main class="accounts">
    <nav class="menu">
      <q-tabs :model-value="activeTab" align="left" class="text-indigo-7 bg-grey-1"
        indicator-color="indigo-7" active-bg-color="indigo-2" inline-label no-caps>
        <q-route-tab v-for="item in menu" :key="item.name" :name="item.name"
          :to="{ name: item.name }" :icon="item.icon"
          :label="client.isMobilePhone ? '' : item.label" />
      </q-tabs>
    </nav>

    <section class="view">
      <router-view v-slot="{ Component }">
        <component :is="Component" v-if="account" :account="account" />
      </router-view>
    </section>
  </main>
</template>

<style scoped lang="scss">
main.accounts {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;

  .menu {
    flex: 0 0 auto;
    border-bottom: solid #9fa8da 1px;
  }

  .view {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
    min-height: 0;
    overflow: auto;
    padding: 16px;
  }
}
</style>
